import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFloat from "@/pages/home/components/WhatsAppFloat";
import AnnouncementBar from "@/pages/home/components/AnnouncementBar";

const PRIVACY_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "سياسة الخصوصية — متجر الإبداع AL Ebdaa",
  "description": "سياسة الخصوصية لمتجر الإبداع AL Ebdaa — تعرّف على كيفية جمع بياناتك واستخدامها وحمايتها عند تسوّقك من متجرنا.",
  "url": `${import.meta.env.VITE_SITE_URL ?? "https://example.com"}/privacy-policy`,
  "inLanguage": "ar-SA",
  "dateModified": "2026-04-07",
  "isPartOf": {
    "@type": "WebSite",
    "name": "متجر الإبداع AL Ebdaa",
    "url": import.meta.env.VITE_SITE_URL ?? "https://example.com"
  }
};

const sections = [
  {
    id: "collect",
    icon: "ri-database-2-line",
    title: "البيانات التي نجمعها",
    content: [
      {
        subtitle: "بيانات الطلبات",
        text: "عند إتمام طلبك، نجمع اسمك الكامل، رقم جوالك، عنوان التوصيل، والمدينة. هذه البيانات ضرورية لمعالجة طلبك وتوصيله إليك.",
      },
      {
        subtitle: "بيانات الحساب",
        text: "إذا اخترت إنشاء حساب، نحتفظ برقم جوالك كمعرّف رئيسي، واسمك، وتاريخ التسجيل. لا نطلب منك بريداً إلكترونياً أو كلمة مرور.",
      },
      {
        subtitle: "بيانات التصفح",
        text: "قد نجمع بيانات تقنية مثل نوع المتصفح ونظام التشغيل لتحسين تجربة الموقع. لا نستخدم ملفات تعريف الارتباط (Cookies) لأغراض تتبع إعلانية.",
      },
    ],
  },
  {
    id: "use",
    icon: "ri-settings-3-line",
    title: "كيف نستخدم بياناتك",
    content: [
      {
        subtitle: "معالجة الطلبات",
        text: "نستخدم بياناتك لمعالجة طلباتك، التواصل معك عبر واتساب لتأكيد الطلب، وتنسيق عملية التوصيل.",
      },
      {
        subtitle: "تحسين الخدمة",
        text: "نحلل أنماط الشراء بشكل مجمّع (دون تحديد هوية أفراد) لتحسين كتالوج منتجاتنا وتجربة التسوق.",
      },
      {
        subtitle: "برنامج المكافآت",
        text: "نستخدم سجل مشترياتك لاحتساب نقاط المكافآت وتحديد مستواك في البرنامج (برونزي، فضي، ذهبي، بلاتيني).",
      },
      {
        subtitle: "التواصل",
        text: "قد نرسل لك إشعارات عبر واتساب تتعلق بحالة طلبك أو عروض حصرية. يمكنك إلغاء الاشتراك في أي وقت.",
      },
    ],
  },
  {
    id: "share",
    icon: "ri-share-line",
    title: "مشاركة البيانات مع أطراف ثالثة",
    content: [
      {
        subtitle: "شركاء التوصيل",
        text: "نشارك اسمك وعنوانك ورقم جوالك مع شركات الشحن المعتمدة لغرض توصيل طلبك فقط.",
      },
      {
        subtitle: "لا بيع للبيانات",
        text: "نؤكد بشكل قاطع أننا لا نبيع بياناتك الشخصية لأي طرف ثالث لأغراض تسويقية أو إعلانية.",
      },
      {
        subtitle: "المتطلبات القانونية",
        text: "قد نكشف عن بياناتك إذا طُلب منا ذلك بموجب القانون أو أمر قضائي صادر من الجهات المختصة في المملكة العربية السعودية.",
      },
    ],
  },
  {
    id: "security",
    icon: "ri-shield-keyhole-line",
    title: "حماية بياناتك",
    content: [
      {
        subtitle: "التشفير والأمان",
        text: "نستخدم بروتوكول HTTPS لتشفير جميع البيانات المنقولة بين متصفحك وخوادمنا. بياناتك محفوظة في قواعد بيانات آمنة مع صلاحيات وصول محدودة.",
      },
      {
        subtitle: "التحقق بالجوال",
        text: "نستخدم نظام التحقق عبر واتساب (OTP) لضمان أن الشخص الذي يصل لحسابك هو أنت فعلاً.",
      },
      {
        subtitle: "الاحتفاظ بالبيانات",
        text: "نحتفظ ببيانات طلباتك لمدة 3 سنوات لأغراض الضمان وخدمة ما بعد البيع. يمكنك طلب حذف بياناتك في أي وقت.",
      },
    ],
  },
  {
    id: "rights",
    icon: "ri-user-settings-line",
    title: "حقوقك",
    content: [
      {
        subtitle: "الوصول والتصحيح",
        text: "يحق لك الاطلاع على بياناتك الشخصية المحفوظة لدينا وطلب تصحيح أي معلومات غير دقيقة.",
      },
      {
        subtitle: "الحذف",
        text: "يمكنك طلب حذف حسابك وجميع بياناتك الشخصية. يُرجى ملاحظة أننا قد نحتفظ ببعض البيانات المطلوبة قانونياً.",
      },
      {
        subtitle: "الاعتراض",
        text: "يحق لك الاعتراض على معالجة بياناتك لأغراض التسويق المباشر في أي وقت.",
      },
    ],
  },
  {
    id: "cookies",
    icon: "ri-file-code-line",
    title: "ملفات تعريف الارتباط (Cookies)",
    content: [
      {
        subtitle: "الاستخدام المحدود",
        text: "نستخدم ملفات تعريف الارتباط الضرورية فقط لتشغيل الموقع، مثل حفظ محتويات سلة التسوق وبيانات الجلسة.",
      },
      {
        subtitle: "لا تتبع إعلاني",
        text: "لا نستخدم ملفات تعريف الارتباط لتتبع نشاطك عبر مواقع أخرى أو لأغراض إعلانية.",
      },
    ],
  },
  {
    id: "updates",
    icon: "ri-refresh-line",
    title: "تحديثات السياسة",
    content: [
      {
        subtitle: "إشعار التغييرات",
        text: "قد نحدّث سياسة الخصوصية هذه من وقت لآخر. سنُعلمك بأي تغييرات جوهرية عبر واتساب أو بإشعار واضح على الموقع.",
      },
      {
        subtitle: "آخر تحديث",
        text: "آخر تحديث لهذه السياسة كان في 7 أبريل 2026.",
      },
    ],
  },
];

export default function PrivacyPolicyPage() {
  const [barVisible, setBarVisible] = useState(true);
  const handleBarVisibility = useCallback((v: boolean) => setBarVisible(v), []);
  const [activeSection, setActiveSection] = useState("collect");

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-privacy";
    script.textContent = JSON.stringify(PRIVACY_SCHEMA);
    document.head.appendChild(script);
    document.title = "سياسة الخصوصية — متجر الإبداع AL Ebdaa";
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "سياسة الخصوصية لمتجر الإبداع AL Ebdaa — تعرّف على كيفية جمع بياناتك واستخدامها وحمايتها عند تسوّقك من متجرنا لأجهزة PS5 وPS4 وكمبيوتر الألعاب."
      );
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
    return () => {
      const el = document.getElementById("schema-privacy");
      if (el) el.remove();
    };
  }, []);

  const scrollToSection = (id: string) => {
    setActiveSection(id);
    const el = document.getElementById(`section-${id}`);
    if (el) {
      const offset = 120;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <div dir="rtl" className="bg-[#0a0a0a] min-h-screen" style={{ fontFamily: "'Cairo', sans-serif" }}>
      <AnnouncementBar onVisibilityChange={handleBarVisibility} />
      <Navbar barVisible={barVisible} />

      <main className="pt-32 pb-24 px-4">
        <div className="max-w-6xl mx-auto">

          {/* Breadcrumb */}
          <div className="flex items-center gap-2 text-xs mb-8">
            <Link to="/" className="text-gray-600 hover:text-gray-400 transition-colors">الرئيسية</Link>
            <i className="ri-arrow-left-s-line text-gray-700"></i>
            <span className="text-gray-400">سياسة الخصوصية</span>
          </div>

          {/* Header */}
          <div className="mb-12">
            <div className="inline-flex items-center gap-2 bg-amber-400/10 border border-amber-400/20 rounded-full px-4 py-1.5 mb-5">
              <i className="ri-shield-check-line text-amber-400 text-sm"></i>
              <span className="text-amber-400 text-xs font-bold tracking-widest uppercase">الخصوصية والأمان</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-black text-white mb-4">سياسة الخصوصية</h1>
            <p className="text-gray-400 text-base max-w-2xl leading-relaxed">
              نحن في متجر الإبداع نأخذ خصوصيتك على محمل الجد. هذه الصفحة توضح بشفافية كيف نجمع بياناتك ونستخدمها ونحميها.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <div className="flex items-center gap-1.5 text-gray-500 text-xs">
                <i className="ri-calendar-line text-amber-400/60"></i>
                <span>آخر تحديث: 7 أبريل 2026</span>
              </div>
              <span className="text-gray-700">•</span>
              <div className="flex items-center gap-1.5 text-gray-500 text-xs">
                <i className="ri-map-pin-line text-amber-400/60"></i>
                <span>المملكة العربية السعودية</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row gap-8">

            {/* Sidebar Navigation */}
            <aside className="w-full lg:w-64 shrink-0">
              <div className="bg-[#111] border border-white/5 rounded-2xl p-4 lg:sticky lg:top-28">
                <p className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4 px-2">المحتويات</p>
                <nav className="flex flex-col gap-1">
                  {sections.map((s) => (
                    <button
                      key={s.id}
                      onClick={() => scrollToSection(s.id)}
                      className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm text-right transition-all cursor-pointer whitespace-nowrap w-full ${
                        activeSection === s.id
                          ? "bg-amber-400/10 text-amber-400 border border-amber-400/20"
                          : "text-gray-500 hover:text-gray-300 hover:bg-white/5"
                      }`}
                    >
                      <i className={`${s.icon} text-base flex-shrink-0`}></i>
                      <span className="truncate">{s.title}</span>
                    </button>
                  ))}
                </nav>

                {/* Contact box */}
                <div className="mt-5 pt-5 border-t border-white/5">
                  <p className="text-gray-600 text-xs mb-3">لديك استفسار؟</p>
                  <a
                    href="https://wa.me/966541138847"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/30 text-[#25D366] font-bold px-3 py-2.5 rounded-xl text-xs transition-all cursor-pointer whitespace-nowrap w-full justify-center"
                  >
                    <i className="ri-whatsapp-line text-sm"></i>
                    تواصل معنا
                  </a>
                </div>
              </div>
            </aside>

            {/* Main Content */}
            <div className="flex-1 min-w-0 flex flex-col gap-8">
              {/* Intro card */}
              <div className="bg-amber-400/5 border border-amber-400/15 rounded-2xl p-6">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-400/15 rounded-xl flex-shrink-0 mt-0.5">
                    <i className="ri-information-line text-amber-400 text-lg"></i>
                  </div>
                  <div>
                    <p className="text-amber-400 font-bold text-sm mb-1">ملاحظة مهمة</p>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      باستخدامك لموقع متجر الإبداع وإتمامك لأي عملية شراء، فإنك توافق على سياسة الخصوصية هذه. إذا كان لديك أي استفسار، لا تتردد في التواصل معنا عبر واتساب.
                    </p>
                  </div>
                </div>
              </div>

              {/* Sections */}
              {sections.map((section) => (
                <div
                  key={section.id}
                  id={`section-${section.id}`}
                  className="bg-[#111] border border-white/5 rounded-2xl overflow-hidden hover:border-white/10 transition-all"
                >
                  {/* Section Header */}
                  <div className="flex items-center gap-4 p-6 border-b border-white/5">
                    <div className="w-11 h-11 flex items-center justify-center bg-amber-400/10 rounded-xl flex-shrink-0">
                      <i className={`${section.icon} text-amber-400 text-xl`}></i>
                    </div>
                    <h2 className="text-white font-black text-lg">{section.title}</h2>
                  </div>

                  {/* Section Content */}
                  <div className="p-6 flex flex-col gap-5">
                    {section.content.map((item, i) => (
                      <div key={i} className="flex gap-4">
                        <div className="w-1.5 h-1.5 rounded-full bg-amber-400 mt-2 flex-shrink-0" />
                        <div>
                          <h3 className="text-white font-bold text-sm mb-1.5">{item.subtitle}</h3>
                          <p className="text-gray-400 text-sm leading-relaxed">{item.text}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}

              {/* Contact Section */}
              <div className="bg-[#111] border border-white/5 rounded-2xl p-6">
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-11 h-11 flex items-center justify-center bg-green-400/10 rounded-xl flex-shrink-0">
                    <i className="ri-contacts-line text-green-400 text-xl"></i>
                  </div>
                  <h2 className="text-white font-black text-lg">تواصل معنا</h2>
                </div>
                <p className="text-gray-400 text-sm leading-relaxed mb-5">
                  إذا كان لديك أي استفسار حول سياسة الخصوصية أو تريد ممارسة أي من حقوقك المذكورة أعلاه، يمكنك التواصل معنا عبر:
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <a
                    href="https://wa.me/966541138847"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 bg-[#25D366]/10 hover:bg-[#25D366]/20 border border-[#25D366]/30 text-[#25D366] font-bold px-5 py-3 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    واتساب: +966 54 113 8847
                  </a>
                  <Link
                    to="/about"
                    className="flex items-center justify-center gap-2 border border-white/10 hover:border-amber-400/30 text-gray-400 hover:text-amber-400 font-bold px-5 py-3 rounded-xl text-sm transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-information-line text-base"></i>
                    من نحن
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
}